import { FC } from 'react';
import { DashboardConnectorType } from '../../../models/StudentDashboard';
import { useUnitConnectorColors } from '../../../hooks/useUnitConnectorColors';

interface Props {
  type: DashboardConnectorType;
}

export const LongConnector: FC<Props> = ({ type }) => {
  const connectorColors = useUnitConnectorColors();
  const longConnectors = {
    locked: (
      <svg width="525" height="111" viewBox="0 0 525 111" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M8 56C8 51.5817 11.5817 48 16 48H525V55C525 59.4183 521.418 63 517 63H8V56Z" fill="#EBE4DC" />
        <path
          d="M525 0L525 54.8572C525 59.2754 521.418 62.8572 517 62.8572L510 62.8572L510 -6.55671e-07L525 0Z"
          fill="#EBE4DC"
        />
        <ellipse cx="517.5" cy="55.5" rx="7.5" ry="7.5" transform="rotate(-180 517.5 55.5)" fill="#BAAF9F" />
        <path
          d="M15 48.1431L15 111L2.38339e-07 111L2.52723e-06 56.1431C2.71158e-06 51.7248 3.58172 48.1431 8 48.1431L15 48.1431Z"
          fill="#EBE4DC"
        />
        <ellipse cx="7.5" cy="55.5" rx="7.5" ry="7.5" transform="rotate(-180 7.5 55.5)" fill="#BAAF9F" />
      </svg>
    ),
    unlocked: (
      <svg width="525" height="111" viewBox="0 0 525 111" fill="none" xmlns="http://www.w3.org/2000/svg">
        <mask id="path-1-inside-1_2169_37029" fill="white">
          <path d="M8 56C8 51.5817 11.5817 48 16 48H525V55C525 59.4183 521.418 63 517 63H8V56Z" />
        </mask>
        <path
          d="M8 56C8 49.3726 13.3726 44 20 44H525V52H16C11.5817 52 8 53.7909 8 56ZM525 55C525 61.6274 519.627 67 513 67H8V59H517C521.418 59 525 57.2091 525 55ZM525 55M8 63V48V63M8 63M525 48V63V48"
          className={connectorColors.fillBase}
          mask="url(#path-1-inside-1_2169_37029)"
        />
        <mask id="path-3-inside-2_2169_37029" fill="white">
          <path d="M525 0L525 54.8572C525 59.2754 521.418 62.8572 517 62.8572L510 62.8572L510 -6.55671e-07L525 0Z" />
        </mask>
        <path
          d="M529 1.74846e-07L529 50.8572C529 57.4846 523.627 62.8572 517 62.8572C519.209 62.8572 521 59.2754 521 54.8572L521 -1.74846e-07L529 1.74846e-07ZM506 62.8572L506 -8.30516e-07L514 -4.80825e-07L514 62.8572L506 62.8572ZM514 62.8572M510 -6.55671e-07L525 0L510 -6.55671e-07M510 -6.55671e-07M525 62.8572L510 62.8572L525 62.8572"
          className={connectorColors.fillBase}
          mask="url(#path-3-inside-2_2169_37029)"
        />
        <ellipse
          cx="517.5"
          cy="55.5"
          rx="7.5"
          ry="7.5"
          transform="rotate(-180 517.5 55.5)"
          className={connectorColors.fillAccent}
        />
        <mask id="path-6-inside-3_2169_37029" fill="white">
          <path d="M15 48L15 110.857L2.38339e-07 110.857L2.52723e-06 56C2.71158e-06 51.5817 3.58172 48 8 48L15 48Z" />
        </mask>
        <path
          d="M19 48L19 110.857L11 110.857L11 48L19 48ZM-4 110.857L-4 60C-4 53.3726 1.37259 48 8 48C5.79086 48 4 51.5817 4 56L4 110.857L-4 110.857ZM4 110.857M2.86102e-06 48L15 48L2.86102e-06 48M2.86102e-06 48M15 110.857L2.38339e-07 110.857L15 110.857"
          className={connectorColors.fillBase}
          mask="url(#path-6-inside-3_2169_37029)"
        />
        <ellipse
          cx="7.5"
          cy="55.5"
          rx="7.5"
          ry="7.5"
          transform="rotate(-180 7.5 55.5)"
          className={connectorColors.fillAccent}
        />
      </svg>
    ),
    passed: (
      <svg width="525" height="111" viewBox="0 0 525 111" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M8 56C8 51.5817 11.5817 48 16 48H525V55C525 59.4183 521.418 63 517 63H8V56Z"
          className={connectorColors.fillBase}
        />
        <path
          d="M525 0L525 54.8572C525 59.2754 521.418 62.8572 517 62.8572L510 62.8572L510 -6.55671e-07L525 0Z"
          className={connectorColors.fillBase}
        />
        <ellipse
          cx="517.5"
          cy="55.5"
          rx="7.5"
          ry="7.5"
          transform="rotate(-180 517.5 55.5)"
          className={connectorColors.fillAccent}
        />
        <path
          d="M15 48L15 110.857L2.38339e-07 110.857L2.52723e-06 56C2.71158e-06 51.5817 3.58172 48 8 48L15 48Z"
          className={connectorColors.fillBase}
        />
        <ellipse
          cx="7.5"
          cy="55.5"
          rx="7.5"
          ry="7.5"
          transform="rotate(-180 7.5 55.5)"
          className={connectorColors.fillAccent}
        />
      </svg>
    ),
  };

  return longConnectors[type];
};
